import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CreateTicketDialogComponent } from '../../../../projects/kiene-core/src/lib/components/create-ticket-dialog/create-ticket-dialog.component';

@Component({
    selector: 'kiene-bug-report-button',
    templateUrl: './bug-report-button.component.html',
    styleUrls: ['./bug-report-button.component.scss'],
})
export class BugReportButtonComponent implements OnInit {
    constructor(private dialog: MatDialog) {}

    public ngOnInit(): void {}

    openCreateTicketDialog() {
        this.dialog.open(CreateTicketDialogComponent, { width: '100%', data: undefined });
    }
}
